import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { customersQueries } from '@/services/customers/customers.queries';
import { CustomersDetails } from '@/services/customers/customers.types';

export const useCustomerDetail = (categoryId: string) => {
  const { data, isFetched } = useQuery({
    ...customersQueries.detail(categoryId),
    select: (res) => ({
      ...res,
      data: res.data,
    }),
  });

  return { customersDetail: data?.data || ({} as CustomersDetails), isFetched };
};
